if (!customElements.get('wlsn-product-comparison-table')) {
  class WlsnProductComparisonTable extends HTMLElement {
    constructor() {
      super();
      this.classess = {
        columnWrapper: 'js-wlsn-column-wrapper',
        headerColumn: 'js-wlsn-header-column',
        bodyColumn: 'js-wlsn-body-column',
        stickyHeader: 'js-wlsn-sticky-header',
        stickyActive: 'is-sticky',
      };
      this.selectors = this.getSelectors();
      this.boundHandleScroll = this.handleScroll.bind(this);
    }

    /**
     * Get DOM element selectors used in the component
     * @returns {Object} Object containing references to DOM elements
     */
    getSelectors() {
      return {
        columnWrappers: this.querySelectorAll(`.${this.classess.columnWrapper}`),
        stickyHeader: this.querySelector(`.${this.classess.stickyHeader}`),
        headerColumns: this.querySelectorAll(`.${this.classess.headerColumn}`),
      };
    }

    /**
     * Lifecycle callback when element is added to DOM
     * Initializes the component functionality
     */
    connectedCallback() {
      this.init();
    }

    /**
     * Lifecycle callback when element is removed from DOM
     * Cleans up event listeners
     */
    disconnectedCallback() {
      window.removeEventListener('resize', () => {
        this.equalizeHeights();
      });
      window.removeEventListener('scroll', this.boundHandleScroll);
    }

    /**
     * Initialize component functionality and set up event listeners
     */
    init() {
      this.equalizeHeights();

      window.addEventListener('resize', () => {
        this.equalizeHeights();
      });
      if (this.selectors.stickyHeader) {
        window.addEventListener('scroll', this.boundHandleScroll);
      }
    }

    handleScroll() {
      const { stickyHeader, headerColumns } = this.selectors;
      if (!stickyHeader || !headerColumns.length) return;
    
      const sectionRect = this.getBoundingClientRect();
      const stickyHeight = stickyHeader.offsetHeight;
      const headerBottom = headerColumns[0].getBoundingClientRect().bottom;
      const topTrigger = headerBottom <= 0;
      const bottomBoundary = sectionRect.bottom >= stickyHeight;
      const shouldBeSticky = topTrigger && bottomBoundary;
      const alreadySticky = stickyHeader.classList.contains(this.classess.stickyActive);
    
      if (shouldBeSticky && !alreadySticky) {
        this.activateStickyHeader();
      } else if (!shouldBeSticky && alreadySticky) {
        this.deactivateStickyHeader();
      }
    }

    activateStickyHeader() {
      this.selectors.stickyHeader.classList.add(this.classess.stickyActive);
    }

    deactivateStickyHeader() {
      this.selectors.stickyHeader.classList.remove(this.classess.stickyActive);
    }

    /**
     * Equalizes heights of headers and body columns across all product columns
     * This ensures consistent layout regardless of content length
     */
    equalizeHeights() {
      if (!this.selectors.columnWrappers.length) return;

      // Reset and equalize header heights
      let maxHeaderHeight = 0;
      this.selectors.columnWrappers.forEach((wrapper) => {
        const header = wrapper.querySelector(`.${this.classess.headerColumn}`);
        if (header) {
          header.style.height = 'auto';
          maxHeaderHeight = Math.max(maxHeaderHeight, header.offsetHeight);
        }
      });

      // Apply max header height
      this.selectors.columnWrappers.forEach((wrapper) => {
        const header = wrapper.querySelector(`.${this.classess.headerColumn}`);
        if (header) {
          header.style.height = `${maxHeaderHeight}px`;
        }
      });

      // Get the number of rows from the first column
      const rowsPerColumn = this.selectors.columnWrappers[0].querySelectorAll(`.${this.classess.bodyColumn}`).length;

      // Reset body row heights
      this.selectors.columnWrappers.forEach((wrapper) => {
        wrapper.querySelectorAll(`.${this.classess.bodyColumn}`).forEach((row) => {
          row.style.height = 'auto';
        });
      });

      // For each row index
      for (let rowIndex = 0; rowIndex < rowsPerColumn; rowIndex++) {
        let maxHeight = 0;

        // Find max height for current row index across all columns
        this.selectors.columnWrappers.forEach((wrapper) => {
          const row = wrapper.querySelectorAll(`.${this.classess.bodyColumn}`)[rowIndex];
          if (row) {
            const height = row.offsetHeight;
            maxHeight = Math.max(maxHeight, height);
          }
        });

        // Apply max height to all rows with current index
        this.selectors.columnWrappers.forEach((wrapper) => {
          const row = wrapper.querySelectorAll(`.${this.classess.bodyColumn}`)[rowIndex];
          if (row) {
            row.style.height = `${maxHeight}px`;
          }
        });
      }
    }
  }
  customElements.define('wlsn-product-comparison-table', WlsnProductComparisonTable);
}
